import { Tabs, Tab, tabClasses, tabPanelClasses, Badge, Box } from '@mui/joy';
import { TabList } from '@mui/joy';

export function TabsSegmented({ tabs, tabIndicesWithErrors, children, activeTab, setActiveTab, sx, size, fullWidth }) {  
  return (
    <Tabs 
      aria-label="tabs" 
      defaultValue={activeTab === undefined ? 0 : undefined} 
      value={activeTab} 
      onChange={(_, newValue) => setActiveTab && setActiveTab(newValue)} 
      sx={{ 
        bgcolor: 'transparent', 
        [`& .${tabPanelClasses.root}`]: { p: 0 }
      }}
    >
      <TabList                
        disableUnderline
        sx={{
          mb: 3,
          p: 0.5,
          gap: 0.5,
          borderRadius: 'md',
          bgcolor: 'background.level1',              
          fontSize: size === 'lg' ? '16px' : '14px',
          fontWeight: '500',
          overflowX: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          [`&& .${tabClasses.root}`]: {
            '--ListItem-minHeight': size === 'sm' ? '2rem' : 'inherit',
            bgcolor: 'transparent',
            py: size === 'lg' ? 1.5 : size === 'md' ? 1 : 0.5,
            px: size === 'lg' ? 1.5 : size === 'md' ? 1 : 0.5,            
            '&:hover': {
              bgcolor: 'transparent',
            },
            width: fullWidth ? '100%' : 'auto',
            minWidth: 'auto',                        
          },
          [`& .${tabClasses.root}[aria-selected="true"], & .${tabClasses.root}[aria-selected="true"]:hover`]: {
            boxShadow: 'xs',
            bgcolor: 'background.surface',
          },          
          ...sx,
        }}
      >
        {tabs.map((tab, index) => (
          <Tab disableIndicator key={tab}>
            {(tabIndicesWithErrors ?? []).includes(index) ? <Badge color="danger" size="sm"><Box sx={{ px: 1}}>{tab}</Box></Badge> : <Box sx={{ px: 1}}>{tab}</Box>}            
          </Tab>
        ))}
      </TabList>
      {children}
    </Tabs>
  )
}
